import React from "react";
import { Box, Card, Typography, alpha } from "@mui/material";

interface StatTileProps {
  label: string;
  value: React.ReactNode;
  icon: React.ReactElement;
  color: string;
  active?: boolean;
  onClick?: () => void;
}

/**
 * Summary tile used at the top of list screens (same look as the
 * Attendance / Medication Orders / Shift Handover tiles).
 */
const StatTile: React.FC<StatTileProps> = ({ label, value, icon, color, active = false, onClick }) => (
  <Card
    elevation={0}
    onClick={onClick}
    sx={{
      p: { xs: 1.5, md: 1, lg: 2.5 },
      height: "100%",
      borderRadius: "16px",
      border: "1px solid",
      borderColor: active ? color : "divider",
      bgcolor: active ? alpha(color, 0.04) : "background.paper",
      cursor: onClick ? "pointer" : "default",
      transition: "all 0.2s",
      "&:hover": {
        boxShadow: `0 4px 16px ${alpha(color, 0.15)}`,
        borderColor: active ? color : alpha(color, 0.5),
      },
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Box sx={{ p: 1.25, borderRadius: "12px", bgcolor: alpha(color, 0.12), color, display: "flex" }}>
        {React.cloneElement(icon, { sx: { fontSize: 28 } })}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h5" sx={{ fontWeight: 800, color, lineHeight: 1, fontSize: "1.75rem" }}>
          {value}
        </Typography>
        <Typography
          variant="caption"
          sx={{ color: "text.secondary", fontWeight: 600, fontSize: "0.82rem", whiteSpace: "nowrap" }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  </Card>
);

export default StatTile;
